<template>
  <div class="full-container">
    <div
        style="width: 100%;float: left;height: 50px;line-height: 50px;font-size: 0.9rem; text-align: left;opacity: 0.9;">
      权限>用户管理
    </div>
    <div style="width:100%;height:auto;float:left;border-radius: 15px;padding-bottom:40px;background-color: white">
      <div style="width:100%;float:left;margin-top: 10px;">
        <!-- 查询按钮区 -->
        <div style="width: 100%;height: 60px;float: left;line-height: 60px;padding-left: 15px">
          <!-- 左边 -->
          <div style="width: auto;float: left;margin-right: 20px;text-align: left;">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">平台：</label>
            <el-select v-model="selectForm.platform" clearable filterable size="mini" style="float: left;">
              <el-option v-for="item in platformList" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">用户账号：</label>
            <el-input v-model="selectForm.no" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                      size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <el-button size="mini" style="background-color: #25AD7F;border:none;" type="primary"
                       @click="pageUser(true)">搜索
            </el-button>
            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="selectReset()">重置
            </el-button>
          </div>

          <!-- 右边按钮 -->
          <div style="width: auto;float: right;margin-right: 20px">
            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="exportTable">
              <a-icon type="plus-circle"/>
              批量导出
            </el-button>
          </div>

        </div>

        <!-- 表单内容 -->
        <div style="width:100%;float:left;padding: 15px;text-align: left;">
          <el-table v-loading="tableLoading" :data="tableData" align="center"  @selection-change="handleSelectionChange"  height="600" size="mini" style="color: #555;">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="平台" min-width="20%" prop="platformStr"></el-table-column>
            <el-table-column align="center" label="用户账号" min-width="20%" prop="no"></el-table-column>
            <el-table-column align="center" label="名称" min-width="20%" prop="name"></el-table-column>
            <el-table-column align="center" label="商户" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row&&scope.row.merchantVO&&scope.row.merchantVO.merchantDetailVO?scope.row.merchantVO.merchantDetailVO.companyName:""}}
              </template>
            </el-table-column>
            <el-table-column align="center" label="最后登录" min-width="20%">
              <template slot-scope="scope">
                {{ parseDate(scope.row.loginDate ? scope.row.loginDate : "") }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="注册时间" min-width="20%">
              <template slot-scope="scope">
                {{ parseDate(scope.row.createDate ? scope.row.createDate : "") }}
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%;float: right;margin-top: 10px;text-align: right;">
            <el-pagination
                :current-page="selectForm.pageIndex"
                :page-size="selectForm.pageSize"
                :total="selectForm.total"
                layout="total,prev, pager, next"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>


import {listPlatformApi} from "@/router/api/common/data-api";


import {pageUserApi} from "@/router/api/user-api";
import * as XLSX from "xlsx";

export default {
  name: "UserIndex",
  data() {
    return {

      platformList: [{
        name:"网页版管理后台",
        value:"web_admin"
      },{
        name:"微信小程序",
        value:"wx_app"
      }],

      //查询
      tableData: [],
      selectForm: {
        no: null,
        platform: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      tableLoading:false,
      selectTableRow: [],

    };
  },

  mounted() {

    this.load();


  },

  methods: {

    load() {

      this.pageUser();

    },
    // 查询 begin

    handleSelectionChange(val) {
      this.selectTableRow = val;
    },

    pageUser(showMessage) {
      this.tableLoading = true;
      pageUserApi(this.selectForm, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              if (showMessage) {
                this.showMessage(res.data.msg, "success");
              }
              this.tableData = res.data.resultSetData.list;
              this.selectForm.pageIndex = res.data.resultSetData.pageNum;
              this.selectForm.pageSize = res.data.resultSetData.pageSize;
              this.selectForm.total = res.data.resultSetData.total;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      }, res => {
        this.tableLoading = false;
      });
    },

    selectReset() {
      this.selectForm = {
        no: null,
        platform: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      };
      this.pageUser(true);
    },

    handleCurrentChange(e) {
      this.selectForm.pageIndex = e;
      this.pageUser(true);
    },

    exportTable() {
      if (!this.selectTableRow || this.selectTableRow.length == 0) {
        this.showMessage("请勾选需要导出的数据", "warning");
        return false;
      }

      const data = [
        [
          "平台",
          "用户账号",
          "名称",
          "商户",
          "最后登录",
          "注册时间"
        ]
      ]
      for (let i = 0; i < this.selectTableRow.length; i++) {
        let row = this.selectTableRow[i];
        if (row) {
          let cell0 = row.platformStr ? row.platformStr : "";
          let cell1 = row.no ? row.no : "";
          let cell2 = row.name ? row.name : "";
          let cell3 =  row && row.merchantVO && row.merchantVO.merchantDetailVO ? row.merchantVO.merchantDetailVO.companyName : ""
          let cell4 = this.parseDate(row.loginDate ? row.loginDate : "")
          let cell5 = this.parseDate(row.createDate ? row.createDate : "")
          data.push([cell0, cell1, cell2, cell3, cell4,cell5]);
        }
      }
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, {bookType: "xlsx", type: "array"});

      // 使用blob和FileReader创建一个Blob URL
      const dataBlob = new Blob([excelBuffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
      const blobUrl = window.URL.createObjectURL(dataBlob);

      // 使用saveAs下载文件
      saveAs(dataBlob, "用户管理-" + new Date().toLocaleString() + ".xlsx");

      // 清理
      window.URL.revokeObjectURL(blobUrl);
    },


    // 工具


    parseDate(date) {
      if (date) {
        return new Date(date).toLocaleString();
      }
      return "";
    }


  }

};

</script>


<style scoped>


/* 树形菜单 */
/deep/ .el-tree-node__content {
  height: 35px;
  line-height: 35px;
}

/* 表格 */
/deep/ .el-table th.el-table__cell {
  background-color: #F8F8F8;
}

/deep/ .el-table th.el-table__cell > .cell {
  color: #554 !important;
  font-weight: 600;
  font-size: 1.05rem;
}


/* 模态框 */
/deep/ .el-dialog__title {
  font-weight: 600;
}

/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid darkgray;
}

/deep/ .el-dialog__body {
  width: 100%;
  float: left;
  background-color: white;
}

/deep/ .el-upload-dragger {
  height: auto;
}

/deep/ .el-form-item__content {
  text-align: left;
}


.dialog-footer {
  width: 100%;
  float: left;
  text-align: left;
}

.dialog-footer-submit {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-submit:hover {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel:hover {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

</style>
